import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN = '[VeranstaltungenModul] PostAufgabeFehlerbeschreibungHinzufuegen laden';
export const POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_AUSFUEHREN = '[VeranstaltungenModul] PostAufgabeFehlerbeschreibungHinzufuegen ausführen';
export const POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_ERFOLGREICH = '[VeranstaltungenModul] PostAufgabeFehlerbeschreibungHinzufuegen laden erfolgreich';
export const POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_FEHLER = '[VeranstaltungenModul] PostAufgabeFehlerbeschreibungHinzufuegen Ladefehler';
export const POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostAufgabeFehlerbeschreibungHinzufuegen nicht ausgeführt (evtl. Offline)';


export class PostAufgabeFehlerbeschreibungHinzufuegenAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN;
        constructor(public aufgabeFehlerbeschreibungRequest: api.AufgabeFehlerbeschreibungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbeschreibungHinzufuegenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_AUSFUEHREN;
        constructor(public aufgabeFehlerbeschreibungRequest: api.AufgabeFehlerbeschreibungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbeschreibungHinzufuegenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeFehlerbeschreibungRequest: api.AufgabeFehlerbeschreibungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbeschreibungHinzufuegenFehlerAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_FEHLER;
        constructor(public payload: any, public aufgabeFehlerbeschreibungRequest: api.AufgabeFehlerbeschreibungRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbeschreibungHinzufuegenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBESCHREIBUNG_HINZUFUEGEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandAufgabeFehlerbeschreibungHinzufuegenActions =
    PostAufgabeFehlerbeschreibungHinzufuegenAction
    | PostAufgabeFehlerbeschreibungHinzufuegenAusfuehrenAction
    | PostAufgabeFehlerbeschreibungHinzufuegenErfolgreichAction
    | PostAufgabeFehlerbeschreibungHinzufuegenFehlerAction
    | PostAufgabeFehlerbeschreibungHinzufuegenNichtAusgefuehrtAction
    ;
